import request from '@/utils/request'

export function updateUserPass(userPass) {
  return request({
    url: '/api/home/sys/headerbar/updatepass',
    method: 'post',
    data: {
      oldPass: userPass.oldPass,
      newPass: userPass.newPass,
      checkPass: userPass.checkPass,
      rsaOldPass: userPass.rsaOldPass,
      rsaNewPass: userPass.rsaNewPass,
      rsaCheckPass: userPass.rsaCheckPass
    }
  })
}

export function updateUserStation(stationId) {
  return request({
    url: '/api/home/sys/headerbar/updateuserstation',
    method: 'post',
    data: {
      stId: stationId
    }
  })
}





// WEBPACK FOOTER //
// ./src/api/user.js